import { useTheme } from "../../../../components/hooks/useTheme";
import { AllTransactions } from "./AllTransactions";

export const Transactions = () => {
  const { themeStyles } = useTheme();

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div>
          <AllTransactions />
        </div>
      </div>
    </div>
  )
}